const runGuardedRequest = ({
  isCurrent,
  request,
  onStart,
  onSuccess,
  onError,
  onFinally,
}) => {
  if (onStart) onStart();

  return request()
    .then((result) => {
      if (!isCurrent()) return undefined;

      if (onSuccess) onSuccess(result);
      return result;
    })
    .catch((error) => {
      if (!isCurrent()) return undefined;

      if (onError) onError(error);
      return undefined;
    })
    .finally(() => {
      if (isCurrent() && onFinally) onFinally();
    });
};

export default runGuardedRequest;
